import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { datenflussState } from "./datenflussType";
import type { AppDispatch, RootState } from "../../app/store";
import { emptyAktiverMesspunkt } from "../geraetemanagement/geraeteManagementSlice";
import { getWithAuth } from "../../utils/api";
import { aktiverMesspunkt, betriebsereignisKommunikation } from "../../utils/apiTypes";
import { logError } from "../../utils/utils";
import { errorHandler } from "../../utils/errorHandling";

const initialState: datenflussState
  = {
  aktiveMesspunkte: [],
  selectedUW: "",
  selectedAktiverMesspunkt: emptyAktiverMesspunkt,
  messpunktLoading: false,
  kommunikation: [],
};

const datenflussSlice = createSlice({
  name: "datenfluss",
  initialState,
  reducers:
  {
    setSelectedUW: (state, action: PayloadAction<string>) => {
      state.selectedUW = action.payload;
    },
    setSelectedAktiverMesspunkt: (state, action: PayloadAction<aktiverMesspunkt>) => {
      state.selectedAktiverMesspunkt = action.payload;
    },
    setAktiveMesspunkte: (state, action: PayloadAction<aktiverMesspunkt[]>) => {
      state.aktiveMesspunkte = action.payload;
    },
    setMesspunktLoading: (state, action: PayloadAction<boolean>) => {
      state.messpunktLoading = action.payload;
    },
    setKommunikation: (state, action: PayloadAction<betriebsereignisKommunikation[]>) => {
      state.kommunikation = action.payload;
    }
  }
});

export const selectSelectedUW = (state: RootState): string => state.datenfluss.selectedUW;
export const selectSelectedAktiverMesspunkt = (state: RootState): aktiverMesspunkt => state.datenfluss.selectedAktiverMesspunkt;
export const selectAktiveMesspunkte = (state: RootState): aktiverMesspunkt[] => state.datenfluss.aktiveMesspunkte;
export const selectMesspunktLoading = (state: RootState): boolean => state.datenfluss.messpunktLoading;
export const selectKommunikation = (state: RootState): betriebsereignisKommunikation[] => state.datenfluss.kommunikation;

export const {
  setAktiveMesspunkte,
  setSelectedUW,
  setSelectedAktiverMesspunkt,
  setMesspunktLoading,
  setKommunikation,
} = datenflussSlice.actions;

export const getAktiveMesspunkte = () => (
  dispatch: AppDispatch
): void => {
  dispatch(setMesspunktLoading(true));
  getWithAuth("AKTIVEMESSPUNKTE", {}).then((response: aktiverMesspunkt[]) => {
    dispatch(setAktiveMesspunkte(response));
  }).catch((error) => {
    logError(error);
    errorHandler(error, dispatch);
  }).finally(() => dispatch(setMesspunktLoading(false)));
}

export const selectMesspunkt = (messpunkt: aktiverMesspunkt) => (
  dispatch: AppDispatch
): void => {
  dispatch(setSelectedAktiverMesspunkt(messpunkt));
  if (messpunkt.name != "") {
    dispatch(setMesspunktLoading(true));

  }
}

export const getKommunkation = () => (dispatch: AppDispatch): void => {
  getWithAuth("KOMMUNIKATION", {})
    .then((response: betriebsereignisKommunikation[]) => {
      dispatch(setKommunikation(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    });
}
export default datenflussSlice.reducer;